import { useState } from 'react';

export const useTrackCurrentSlide = (): [number, React.Dispatch<React.SetStateAction<number>>] => {
  return useState(0);
};
